(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["modal-popup"] && !Shopify.designMode) return;
  try {
    

  (function(){

    /**
     * Find the modal using its generic identifier, 
     * then replace the identifier with a more unique one.
     */

    const modalElement = document.querySelector("#modal");

    modalElement.setAttribute("id", modalElement.dataset.modalId);
    
    const MODAL_ID = `#${modalElement.dataset.modalId}`;

    console.log(MODAL_ID)

    if(!modalElement){
      console.error("Modal element could not found with document.querySelector");
      return;
    }


    /**
      * Determine if the form has already been submitted,
      * if so then display the modal as soon as the page loads
      */

    const modalFormSubmitted = document.querySelector(`${MODAL_ID}__submitted`).dataset.modalFormSubmitted === "true";

    /**
     * The trigger selector is an html selector for an element
     * ex: .mybutton, #mybutton
     * to toggle the modals visibility
     */

    const MODAL_TRIGGER_SELECTOR = modalElement.dataset.modalTriggerSelector;

    console.log(MODAL_TRIGGER_SELECTOR);

    if(MODAL_TRIGGER_SELECTOR.trim().length <= 0) {
      console.error("The modal trigger selector is empty. Please provide one.");
      return;
    }
    
    const modalTriggerElement = document.querySelector(MODAL_TRIGGER_SELECTOR);

    if(!modalTriggerElement) {
      console.error("The modal trigger element could not be found with document.querySelector");
      return;
    }

    console.log(modalTriggerElement);

    /**
     * The close button and backdrop toggles the modals visiblity upon interaction
     */
    
    const modalCloseBtn = document.querySelector(`${MODAL_ID} > .modal__content > .modal__header > .modal__closeBtn`);

    console.log(modalCloseBtn)

    const modalBackdrop = document.querySelector(`${MODAL_ID} > .modal__backdrop`);

    console.log(modalBackdrop)

    function toggleModalVisibility() { 

      if(modalElement.style.display != "flex") {
        
        /**
         * When the modal is set to not display
         * Allow the modal to display
         */
        
        modalElement.style.display = "flex";
        
        /**
         * Set the opacity of the modal to 1 in order to 
         * trigger the entering transition 
         */
        
        setTimeout(() => { // The timeout allows for the appended class to be set
          modalElement.classList.add("modal--show");
        }, 0);
        
        return;
      }

      /**
       * When the modal is set to display remove the show class which
       * will set the opacity to 0, triggering an exit transition
       */

      modalElement.classList.remove("modal--show");

      /**
       * When the exit transition ends, remove the modal from view
       */
      
      setTimeout(() => {
        modalElement.style.display = "none";
      }, 300);
      
    }

    // Opening the modal
    modalTriggerElement.addEventListener("click", toggleModalVisibility);

    modalCloseBtn.addEventListener("click", toggleModalVisibility);

    if(modalFormSubmitted) {
      toggleModalVisibility();
    }
    
    // Closing the modal
    modalBackdrop.addEventListener("click", toggleModalVisibility);


    
  })();

  } catch(e) { console.error(e); }
})();
})();
